import { MaterialTypeEnum } from "@ns/types";

export const materialTypeMapper = (materialType: MaterialTypeEnum) => {
  switch (materialType) {
    case MaterialTypeEnum.GRANITE:
      return "GRANIT";
    case MaterialTypeEnum.MARBLE:
      return "MERMER";
    case MaterialTypeEnum.ONYX:
      return "ONIKS";
    case MaterialTypeEnum.QUARTZ:
      return "KVARC";
    case MaterialTypeEnum.TRAVERTINE:
      return "TRAVERTIN";
    case MaterialTypeEnum.PESCAR:
      return "PESCAR";
    case MaterialTypeEnum.KERAMIKA:
      return "KERAMIKA";
    case MaterialTypeEnum.VESTAK:
      return "VESTAK";
    case MaterialTypeEnum.KRECNJAK:
      return "KRECNJAK";
    case MaterialTypeEnum.QUARZITE:
      return "KVARCIT";
  }
};
